import { connect } from "react-redux";
import { DesignChapter } from "@learningblocks/storybook-components";
import { viewThreeDrop, viewThreeRemoveStep } from "@learningblocks/exp-redux";

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    onDropStep: (params) => dispatch(viewThreeDrop(params)),
    onRemoveStep: (params) => dispatch(viewThreeRemoveStep(params)),
  };
}

export const GroupC = connect(
  mapStateToProps,
  mapDispatchToProps
)(DesignChapter.GroupC);
